(function () {
    'use strict';

    angular
        .module('appback')
        .controller('DistribuidorController', DistribuidorController)

    DistribuidorController.$inject = ["DistribuidorService"];

    function DistribuidorController(DistribuidorService) {
        var dc = this;

        var url = new URL(window.location.href);

        dc.ficha = null;
        dc.loading = true;
        dc.notFound = false;
        dc.distribuidorId = url.searchParams.get('id');

        dc.tabs = [
            { id: 'resumen', name: 'Resumen' },
            { id: 'paises', name: 'Países' },
            { id: 'productos', name: 'Productos' },
            { id: 'contactos', name: 'Contactos' },
            { id: 'pedidos', name: 'Pedidos' },
            { id: 'analisis', name: 'Análisis IA' },
            { id: 'estrategia', name: 'Estrategia' },
            { id: 'followup', name: 'Follow-up' },
            { id: 'historico', name: 'Histórico' }
        ];
        dc.tab = dc.tabs[0];

        // Año elegido en la pestaña Pedidos ('' = todos).
        dc.anio = '';

        dc.getficha = function () {
            dc.loading = true;

            DistribuidorService.GetFicha(dc.distribuidorId).then(function (response) {
                dc.ficha = response;
                dc.anio = dc.ficha.anios.length ? dc.ficha.anios[0].anio : '';
            }, function () {
                dc.ficha = null;
                dc.notFound = true;
            }).finally(function () {
                dc.loading = false;
            });
        };

        dc.cambiarTab = function (tab) {
            dc.tab = tab;
        };

        // Años que se ven en Pedidos según el filtro.
        dc.aniosFiltrados = function () {
            return dc.ficha.anios.filter(function (anio) {
                return !dc.anio || anio.anio === dc.anio;
            });
        };

        // "89.945 €": sin decimales, en la moneda del distribuidor.
        dc.importe = function (valor) {
            if (valor === null || valor === undefined || valor === '') {
                return '—';
            }

            try {
                return new Intl.NumberFormat('es-ES', { style: 'currency', currency: dc.ficha.moneda || 'EUR', maximumFractionDigits: 0 }).format(valor);
            } catch (e) {
                return Math.round(valor) + ' ' + (dc.ficha.moneda || '');
            }
        };

        dc.numero = function (valor, decimales) {
            if (valor === null || valor === undefined || valor === '') {
                return '—';
            }

            return Number(valor).toLocaleString('es-ES', { minimumFractionDigits: decimales || 0, maximumFractionDigits: decimales || 0 });
        };

        dc.texto = function (valor) {
            if (valor === null || valor === undefined || valor === false) {
                return '';
            }

            var texto = String(valor).trim();
            return texto === 'null' ? '' : texto;
        };

        dc.valor = function (valor) {
            return dc.texto(valor) || '-';
        };

        dc.formatDia = function (fecha) {
            var texto = dc.texto(fecha);
            if (!texto || texto.indexOf('0000-00-00') === 0) {
                return '';
            }

            var date = new Date(texto.replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return texto;
            }

            return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
        };

        dc.formatFecha = function (fecha) {
            var texto = dc.texto(fecha);
            if (!texto || texto.indexOf('0000-00-00') === 0) {
                return '';
            }

            var date = new Date(texto.replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return texto;
            }

            return date.toLocaleString('es-ES', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        };
    }
})();
